__turbopack_context__.v({
  "back": "ErrorModal-module-scss-module__AuHcJW__back",
  "body": "ErrorModal-module-scss-module__AuHcJW__body",
  "btn": "ErrorModal-module-scss-module__AuHcJW__btn",
  "btn-alt": "ErrorModal-module-scss-module__AuHcJW__btn-alt",
  "btn-default": "ErrorModal-module-scss-module__AuHcJW__btn-default",
  "btn-default-dark-bg": "ErrorModal-module-scss-module__AuHcJW__btn-default-dark-bg",
  "btn-disabled": "ErrorModal-module-scss-module__AuHcJW__btn-disabled",
  "btn-elite": "ErrorModal-module-scss-module__AuHcJW__btn-elite",
  "btn-gold": "ErrorModal-module-scss-module__AuHcJW__btn-gold",
  "btn-lg": "ErrorModal-module-scss-module__AuHcJW__btn-lg",
  "btn-link": "ErrorModal-module-scss-module__AuHcJW__btn-link",
  "btn-plat": "ErrorModal-module-scss-module__AuHcJW__btn-plat",
  "btn-primary": "ErrorModal-module-scss-module__AuHcJW__btn-primary",
  "btn-sm": "ErrorModal-module-scss-module__AuHcJW__btn-sm",
  "btn-success": "ErrorModal-module-scss-module__AuHcJW__btn-success",
  "btn-warning": "ErrorModal-module-scss-module__AuHcJW__btn-warning",
  "button": "ErrorModal-module-scss-module__AuHcJW__button",
  "disabled": "ErrorModal-module-scss-module__AuHcJW__disabled",
  "heading": "ErrorModal-module-scss-module__AuHcJW__heading",
  "modal": "ErrorModal-module-scss-module__AuHcJW__modal",
  "overlay": "ErrorModal-module-scss-module__AuHcJW__overlay",
});
